import * as Factory from 'factory.ts'
import faker from 'faker'

import { AddressConstructorFactory } from '@webapp/core/entities/internal/Address/Address.factory'
import { LegalEntitySummaryFactory } from '@webapp/core/entities/internal/LegalEntitySummary'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type PrimaryCategoryConfigDetailConstructor,
  PrimaryCategoryConfigDetail,
} from './PrimaryCategoryConfigDetail'

export const PrimaryCategoryConfigDetailConstructorFactory =
  Factory.Sync.makeFactory<PrimaryCategoryConfigDetailConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    email: Factory.each(() => faker.internet.email()),
    phoneOne: Factory.each(() => faker.phone.phoneNumber()),
    fax: Factory.each(() => faker.phone.phoneNumber()),
    url: Factory.each(() => faker.internet.url()),
    externalId: Factory.each(() => faker.random.alphaNumeric(10)),
    active: true,
    headquarter: false,
    editable: true,
    logo: Factory.each(() => faker.random.uuid()),
    locationTimezone: Factory.each(() => 'America/Los_Angeles'),
    language: 1,
    currency: 1,
    primaryBillingAddress: Factory.each(() =>
      AddressConstructorFactory.build()
    ),
    primaryShippingAddress: Factory.each(() =>
      AddressConstructorFactory.build()
    ),
    shippingAddresses: Factory.each(() => []),
    legalEntity: Factory.each(() => LegalEntitySummaryFactory.build()),
  })

export const PrimaryCategoryConfigDetailFactory = EntityFactory(
  PrimaryCategoryConfigDetail,
  PrimaryCategoryConfigDetailConstructorFactory
)
